export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-200">
      <div className="max-w-[1300px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                91电影视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              高清影视在线平台，提供超清4K画质电影电视剧免费在线观看，流畅不缓冲，支持高速下载，带来极致视听体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">精选视频</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">更新快讯</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">帮助中心</h3>
            <ul className="space-y-2.5">
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">实用指南</a></li>
              <li><a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500">
              更多合作伙伴即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020 - 2026 91电影视频 版权所有 | 本站所有资源均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-primary-400 transition-colors">服务条款</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}